export default {

  "home": {
    "name": "MOQO Home",
    "image": "/decks/backs/home.png"
  },

  "redbooth": {
    "name": "Redbooth",
    "image": "/decks/backs/redbooth.png"
  },

  "work": {
    "name": "MOQO Work",
    "image": "/decks/backs/work.png"
  }

}